import { render, staticRenderFns } from "./BaseMoney.vue?vue&type=template&id=014f524e"
import script from "./BaseMoney.vue?vue&type=script&lang=js"
export * from "./BaseMoney.vue?vue&type=script&lang=js"
import style0 from "./BaseMoney.vue?vue&type=style&index=0&id=014f524e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports